/** Minuscules sans accents : « Électricité » et « electricite » se retrouvent. */
export function normaliser(texte: string): string {
  return texte.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
}

/**
 * Filtre par mots-clés : chaque mot saisi doit apparaître dans l'un des champs
 * (« chauffe eau 200 » trouve « Remplacement chauffe-eau 200 litres »).
 */
export function rechercher<T>(elements: T[], saisie: string, champs: (e: T) => (string | undefined)[]): T[] {
  const mots = normaliser(saisie).split(/[\s\-']+/).filter(Boolean)
  if (mots.length === 0) return elements
  return elements.filter((e) => {
    const texte = normaliser(champs(e).filter(Boolean).join(' ')).replace(/[-']/g, ' ')
    return mots.every((m) => texte.includes(m))
  })
}
